import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Wishlist.css";
import { cartUtils, wishlistUtils } from "../utils/userCartWishlistUtils";
import axios from "axios";
import Prefooterads from "../Homecomponents/Prefooterads";
import ProgressLoader from "../Loader/ProgressLoader";
import Swal from "sweetalert2";
import { showMyAlert } from "../../utils/alertService";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";

const Wishlist = () => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [showSizeModal, setShowSizeModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const loadWishlistItems = async () => {
      try {
        const wishlist = wishlistUtils.getWishlist();
        const productIds = wishlist;

        // Fetch all products
        const productRes = await axios.get(
          "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList"
        );

        const allProducts = productRes.data;

        const items = productIds
          .map((id) => {
            const product = allProducts.find(
              (p) => p.id.toString() === id.toString()
            );

            if (!product) return null;

            return {
              id,
              ...product,
            };
          })
          .filter(Boolean);


        setWishlistItems(items.reverse());
        setLoading(false);
      } catch (error) {
        console.error("Error loading wishlist items:", error);
        setLoading(false);
      }
    };

    loadWishlistItems();
  }, []);

  const handleRemoveFromWishlist = async (productId) => {
  const isConfirmed = await Swal.fire({
    title: "Remove this item?",
    icon: "warning",
    showCancelButton: true,
    heightAuto: false,
    padding: "8px 12px",
    customClass: {
      title: "swal-small-title",
      popup: "swal-small-popup",
      confirmButton: "swal-small-btn",
      cancelButton: "swal-small-btn"
    }
  }).then(r => r.isConfirmed);

    if (!isConfirmed) return;

    try {
      const success = await wishlistUtils.removeFromWishlist(productId);
      if (success) {
        setWishlistItems((prev) =>
          prev.filter((item) => item.id !== productId)
        );
      }
    } catch (error) {
      console.error("Error removing product from wishlist:", error);
    }
  };

  const handleMoveToCart = (product) => {
    setSelectedProduct(product);
    setSelectedSize("");
    setShowSizeModal(true);
  };

  const handleConfirmMoveToCart = async () => {
    if (!selectedSize) {

            showMyAlert({
              type: "warning",
              title: "Select Size",
              message: "Please select a size first",
              duration: 2500,   
            })
      return;
    }

    try {
      const cartSuccess = await cartUtils.addToCart(
        selectedProduct.id, 
        1, 
        selectedSize
      );

      if (cartSuccess) {
        const wishlistSuccess = await wishlistUtils.removeFromWishlist(
          selectedProduct.id
        );
        if (wishlistSuccess) {
          setWishlistItems((prev) =>
            prev.filter((item) => item.id !== selectedProduct.id)
          );
          setShowSizeModal(false);
          setSelectedProduct(null);
          setSelectedSize("");
        }
      } else {
        setShowAlert(true);
        setShowSizeModal(false);
      }
    } catch (error) {
      console.error("Error moving to cart:", error);
    }
  };

  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };
  const getProductVariants = (product) => {
    try {
      return product.variants ? JSON.parse(product.variants) : [];
    } catch (e) {
      console.error("Error parsing variants", e);
      return [];
    }
  };

  if (loading) {
    return (
      <>
        <div className="seeall-main-container">
            <div className="home-subcategory-section">
              <div className="subcategory-header">
                <div className="skeleton-shimmer skeleton-line medium" style={{ height: "20px" }}></div>
                <div className="skeleton-shimmer skeleton-line short" style={{ height: "20px" }}></div>
              </div>
                <div className="seeall-products-grid">
                  {Array(10).fill(0).map((_, idx) => (
                    <SkeletonLoader key={idx} />
                  ))}
                </div>
            </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="wishlistnew-main-container">
        <h2 className="wishlistnew-page-title" style={{ color: "#920504" }}>
          <i className="fa fa-heart me-2"></i> My Wishlist
        </h2>

        {wishlistItems.length === 0 ? (
          <div className="wishlistnew-empty-message">
            <p>Your wishlist is empty. Start adding products you love!</p>
            <button 
              className="wishlistnew-continue-btn" 
              onClick={() => navigate("/")}
            >
              Continue Shopping
            </button>
          </div>
        ) : (
          <div className="wishlistnew-products-grid">
            {wishlistItems.map((item) => (
              <div key={item.id} className="wishlistnew-product-card">
                <div
                  className="wishlistnew-product-image-container"
                  onClick={() => handleProductClick(item)}
                >
                  <img
                    src={
                      item.productImage
                        ? `https://api.dremerz.net/uploads/${item.productImage}`
                        : "/default-product.jpg"
                    }
                    loading="lazy"
                    alt={item.productName || "Product"}
                    className="wishlistnew-product-image"
                  />
                  {item.tags && (
                    <span className="wishlistnew-product-tag">{item.tags}</span>
                  )}
                </div>
                <div className="wishlistnew-product-info m-0">
                  <h3 onClick={() => handleProductClick(item)} className="m-0 wishlistnew-product-brandname">
                    {item.brandName || item.productName}
                  </h3>
                  <p className="wishlistnew-product-name m-0">
                    {item.productName}
                  </p>
                  <div
                    className="wishlistnew-product-price m-0"

                  >
                    <span
                      className="wishlistnew-current-price"
                    >
                      ₹{item.sellingPrice}
                    </span>

                    {item.originalPrice && (
                      <>
                        <span
                          className="wishlistnew-original-price"
                        >
                          ₹{item.originalPrice}
                        </span>
                        <span
                          className="wishlistnew-offer"

                        >
                          (
                          {Math.round(
                            ((item.originalPrice - item.sellingPrice) /
                              item.originalPrice) *
                              100
                          )}
                          % OFF)
                        </span>
                      </>
                    )}
                  </div>

                  <div className="wishlistnew-product-actions">
                    <button
                      className="wishlistnew-move-to-cart-btn"
                      onClick={() => handleMoveToCart(item)}
                    >
                      Add To Cart
                    </button>
                    <button
                      className="wishlistnew-remove-btn"
                      onClick={() => handleRemoveFromWishlist(item.id)}
                    >
                      <i className="fa fa-trash"></i>
                      
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {showSizeModal && selectedProduct && (
        <div className="wishlistnew-modal-overlay">
          <div className="wishlistnew-modal-content">
            <div className="wishlistnew-modal-header">
              <h5 className="wishlistnew-modal-title">Select Size</h5>
              <button
                type="button"
                className="wishlistnew-modal-close"
                onClick={() => {
                  setShowSizeModal(false);
                  setSelectedProduct(null);
                  setSelectedSize("");
                }}
              >
                &times;
              </button>
            </div>
            <div className="wishlistnew-modal-body">
              <p>Please select a size for <strong>{selectedProduct.productName}</strong></p>
              <div className="wishlistnew-size-options">
                {getProductVariants(selectedProduct).map((variant) => (
                  variant.stockQuantity > 0 && (
                    <button
                      key={variant.variantUnit}
                      className={`wishlistnew-size-btn ${
                        selectedSize === variant.variantUnit ? 'wishlistnew-size-selected' : ''
                      }`}
                      onClick={() => setSelectedSize(variant.variantUnit)}
                    >
                      {variant.variantUnit}
                    </button>
                  )
                ))}

                {/* show message if no variant has stock */}
                {getProductVariants(selectedProduct).every(v => v.stockQuantity <= 0) && (
                  <p className="wishlistnew-outofstock-text" style={{color: "red"}}>All sizes are currently out of stock.</p>
                )}

                {/* show message if no variants at all */}
                {getProductVariants(selectedProduct).length === 0 && (
                  <p>No sizes available for this product.</p>
                )}
              </div>
            </div>
            <div className="wishlistnew-modal-footer">
              <button
                type="button"
                className="wishlistnew-modal-cancel"
                onClick={() => {
                  setShowSizeModal(false);
                  setSelectedProduct(null);
                  setSelectedSize("");
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="wishlistnew-modal-confirm"
                onClick={handleConfirmMoveToCart}
                disabled={!selectedSize}
              >
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      )}
      {showAlert && (
        <div className="wishlistnew-alert-overlay">
          <div className="wishlistnew-alert-content">
            <div className="wishlistnew-alert-header">
              <h5 className="wishlistnew-alert-title">Login Required</h5>
              <button
                type="button"
                className="wishlistnew-alert-close"
                onClick={() => setShowAlert(false)}
              >
                &times;
              </button>
            </div>
            <div className="wishlistnew-alert-body">
              <p>Please login to continue.</p>
            </div>
            <div className="wishlistnew-alert-footer">
              <button
                type="button"
                className="wishlistnew-alert-cancel"
                onClick={() => setShowAlert(false)}
              >
                Close
              </button>
              <button
                type="button"
                className="wishlistnew-alert-login"
                onClick={() => navigate("/login")}
              >
                Login
              </button>
            </div>
          </div>
        </div>
      )}
      <Prefooterads />
    </>
  );
};

export default Wishlist;